import React from "react";
import Card from "../../../components/card/Card";
import ModalMsg from "../../../components/ModalMsg";
import Translate from "../../../components/Translate";
import TabellaKpiController from "./components/TabellaKpiController";

export default function ModificaDatiKpiView({
                                                kpi,
                                                translate,
                                                show,
                                                setShow,
                                                modalMsg,
                                                nuovoStato,
                                                setNuovoStato,
                                                formikRef,
                                                aggiornaStatoKpi,
                                                showInfoMessage,
                                                daSalvare,
                                                strutturaKpi,
                                                updateStrutturaKpi,
                                                bottoniSx,
                                                bottoniDx,
                                                handleChangeKpi,
                                            }) {

    return (
        <Card
            title={`${kpi.codice} - ${kpi.descrizione} (` + (kpi.tipo_imp_dati || '') + `)`}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <ModalMsg
                show={show}
                handleClose={() => {
                    setShow(false);
                }}
                testo={modalMsg}/>
            {
                kpi && kpi.stati_successivi.length > 0 &&
                <div className={"row mb-4"}>
                    <div className={"col-md-1"}>
                        <h5><Translate>Stato: </Translate></h5>
                    </div>
                    <div className={"col-md-2"}>
                        <select
                            className={"form-select"}
                            value={nuovoStato}
                            onChange={(event) => setNuovoStato(event.target.value)}
                        >
                            {
                                kpi.stati_successivi.map((s) => <option value={s.id_stato_kpi}
                                                                        key={s.id_stato_kpi}>{s.descrizione}</option>)
                            }
                        </select>
                    </div>
                    <div className={"col-md-2"}>
                        <button
                            type={"button"}
                            className={"btn btn-dark m-0"}
                            onClick={() => {
                                formikRef.current.handleSubmit();

                                setTimeout(() => {
                                    if (Object.keys(formikRef.current.errors).length === 0) {
                                        aggiornaStatoKpi();
                                    } else {
                                        showInfoMessage(translate("Valorizzare tutti i campi"));
                                    }
                                }, 200);
                            }}
                            disabled={nuovoStato === '' || nuovoStato == kpi.id_stato_kpi || daSalvare}
                        >
                            <i className="fas fa-check"/>&nbsp;<Translate>Conferma</Translate>
                        </button>
                    </div>
                </div>
            }
            {
                strutturaKpi &&
                <div className={"row"}>
                    <div className={"col-md-12 mt-4"}>
                        <TabellaKpiController
                            tabella={strutturaKpi}
                            idKpi={kpi.id_kpi}
                            id_tipo_imp_dati={kpi.id_tipo_imp_dati}
                            updateTabella={updateStrutturaKpi}
                            modifica={kpi.codice_stato_kpi === 'BZ'} // Permetto la modifica del KPI solo se è in stato Bozza
                            formikRef={formikRef}
                            handlerChange={handleChangeKpi}
                        />
                    </div>
                </div>
            }
        </Card>
    );
}